var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vpn-app-root",attrs:{"id":"app"}},[_c('to-top',{staticClass:"totop"}),_c('router-view'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }